import { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { getValidToken } from "../../../utils/tokenManager";

/**
 * Extracted from admin/ClientDashboard.jsx - same fetch, same endpoint
 * (GET /api/dashboard/client-panel), same summaryRows field mapping.
 * The desktop-only custom scrollbar-thumb dragging logic for the wide
 * table is NOT ported here - mobile shows one card per month instead of
 * a horizontally-scrollable table, so that whole mechanism doesn't apply.
 */
export function useClientPanel() {
  const { t } = useTranslation();
  const [dashboardData, setDashboardData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        setError(null);
        const accessToken = await getValidToken();
        const response = await axios({
          method: "get",
          url: `${process.env.REACT_APP_APIBASEURL}/api/dashboard/client-panel`,
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        setDashboardData(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  const months = dashboardData?.months || [];

  const monthCards = useMemo(() => {
    return months.map((m) => ({
      label: m.label || "",
      contacts: m.total_leads ?? "-",
      calls: m.total_calls_made ?? "-",
      answered: m.total_calls_answered ?? "-",
      interested: m.total_interested ?? "-",
      scheduled: m.total_meetings_booked ?? "-",
      effective: m.total_meetings_confirmed_attended ?? "-",
      remaining: m.total_contacts_remaining ?? "-",
    }));
  }, [months]);

  return { dashboardData, error, loading, monthCards };
}